import { lazy } from 'react';

export const Dashboard = lazy(() => import('./Dashboard'));
export const Projects = lazy(() => import('./Projects'));
export const ProjectDetail = lazy(() => import('./ProjectDetail'));
export const ProtocolDetail = lazy(() => import('./ProtocolDetail'));
export const Todos = lazy(() => import('./Todos'));
export const Participants = lazy(() => import('./Participants'));
export const Search = lazy(() => import('./Search'));